import React from "react";
import { Outlet } from "react-router";
import BottomNav from "../../components/navbar/BottomNav";
import NavBar from "../../components/navbar/NavBar";
import styles from "./Account.module.css";

function Account(props) {
  return (
    <div>
      <NavBar title="Wallet" setShowMenu={props.setShowMenu} />
      <div className={styles.head}>
        <div className={styles.main_hero}>
          <Outlet />
        </div>
      </div>
      <BottomNav />
    </div>
  );
}

export default Account;
